import Vue from 'vue';
import Vuex from 'vuex';
import linkUser from './modules/linkUser/linkUser.module';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    linkUser,
  },
  strict: debug,
});



// WEBPACK FOOTER //
// ./src/store/index.js